// ================================================
//   WAYNE ENTERPRISES - Homepage Component (JSX)
// ================================================
import "./WayneEnterprises.css";
import { useState, useEffect, useRef } from "react";

// ─── TRADUCCIONES ────────────────────────────────
const translations = {
  ES: {
    langBtn: "ES",
    ultimosLanzamientos: "ULTIMOS LANZAMIENTOS",
    lanzamientos: "LANZAMIENTOS",
    nuestrasDivisiones: "NUESTRAS DIVISIONES",
    divisiones: "DIVISIONES",
    automotiveText: "Mediante nuestra división de tecnología y defensa, AG Industries Limited, desarrollamos proyectos propios enfocados en software, hardware, ingeniería avanzada e innovación estratégica, núcleo de iniciativas y verticales Startup como NM Live de Nacional Media Group, In Jet, o desarrollos reservados como Zero Energy, VV Project y Atlas System AI.",
    automotiveBtn: "Conoce mas",
    lifestyleText: "Somos un ecosistema multisectorial con presencia en sectores como tecnología y defensa, media, comunicación, entretenimiento, turismo, lujo, lifestyle, arte, experiencias premium, startups e inversiones estratégicas, bajo la dirección de nuestro fundador, AG Enterprises Limited continúa desarrollando proyectos que integran innovación, creatividad y una exclusiva visión de futuro en México, con impacto global.",
    casaAgTitle: "CASA AG",
    casaAgText: "Casa Antonio González es la matriz de nuestro universo en el mundo del vino, construyendo una nueva industria en el Estado de Veracruz, sumando cultura, lujo y experiencias, marcas como Bodega Antonio González, AG Purple Effervescence, Festival VV y Reina del Vino, están unidas por la misma innovación, estética, origen y visión de futuro.",
    casaAgBtn: "Explorar",
    experienceTitle: "The AG Gallery Experience",
    experienceText: "Nuestro fundador es un artista por naturaleza, The AG Gallery nace impulsada por distintas divisiones del ecosistema como Maison Santa Fé, Festival VV y Casa Antonio González con la visión de promover el arte, cultura y experiencias únicas, con presencia en Santa Fé, Ciudad de México y San Andrés Tuxtla, Veracruz, busca convertirse en un punto de encuentro entre creativos, empresas y marcas de nicho.",
    experienceBtn: "Conoce mas",
    newsletterTitle: "Become an Insider",
    newsletterSub: "Subscribe for new arrivals and upcoming events.",
    newsletterBtn: "Subscribe",
    newsletterConsent: "I agree to receiving marketing emails and special deals",
    footerCopy: "AG Enterprises Limited ™ - © Todos los derechos reservados.",
    searchPlaceholder: "Buscar...",
    searchEmpty: "Sin resultados para",
    quickViewDefault: "Startup",
  },
  EN: {
    langBtn: "EN",
    ultimosLanzamientos: "LATEST LAUNCHES",
    lanzamientos: "LAUNCHES",
    nuestrasDivisiones: "OUR DIVISIONS",
    divisiones: "DIVISIONS",
    automotiveText: "Through our technology and defense division, AG Industries Limited, we develop proprietary projects focused on software, hardware, advanced engineering, and strategic innovation — core to startup initiatives like NM Live from Nacional Media Group, In Jet, and reserved developments such as Zero Energy, VV Project, and Atlas System AI.",
    automotiveBtn: "Learn more",
    lifestyleText: "We are a multisectoral ecosystem with presence in sectors such as technology and defense, media, communication, entertainment, tourism, luxury, lifestyle, art, premium experiences, startups and strategic investments. Under our founder's leadership, AG Enterprises Limited continues developing projects that integrate innovation, creativity, and an exclusive vision for the future in Mexico, with global impact.",
    casaAgTitle: "CASA AG",
    casaAgText: "Casa Antonio González is the cornerstone of our universe in the world of wine, building a new industry in the State of Veracruz, blending culture, luxury, and experiences. Brands such as Bodega Antonio González, AG Purple Effervescence, Festival VV, and Reina del Vino are united by the same innovation, aesthetics, origin, and vision for the future.",
    casaAgBtn: "Explore",
    experienceTitle: "The AG Gallery Experience",
    experienceText: "Our founder is an artist by nature. The AG Gallery was born driven by different divisions of the ecosystem such as Maison Santa Fé, Festival VV, and Casa Antonio González, with the vision of promoting art, culture, and unique experiences. With a presence in Santa Fé, Mexico City and San Andrés Tuxtla, Veracruz, it seeks to become a meeting point for creatives, businesses, and niche brands.",
    experienceBtn: "Learn more",
    newsletterTitle: "Become an Insider",
    newsletterSub: "Subscribe for new arrivals and upcoming events.",
    newsletterBtn: "Subscribe",
    newsletterConsent: "I agree to receiving marketing emails and special deals",
    footerCopy: "AG Enterprises Limited ™ - © All rights reserved.",
    searchPlaceholder: "Search...",
    searchEmpty: "No results for",
    quickViewDefault: "Startup",
  },
};

const featuredProducts = [
  { id: 1, vendor: "In Jet - Startup", title: "  ", price: " ", image: "/IMG2.jpeg" },
  { id: 2, vendor: "E 0 - Startup", title: " ", price: " ", image: "/IMG6.jpeg" },
  { id: 3, vendor: "NM Live - Startup", title: " ", price: " ", image: "/IMG7.jpeg" },
  { id: 4, vendor: "Atlas AI - Startup", title: " ", price: " ", image: "/IMG8.jpeg" },
];

const lifestyleProducts = [
  { id: 5, vendor: "AG INDUSTRIES LIMITED", title: " ", price: " ", image: "/IMG12.jpeg", quickView: { ES: "Tecnología y defensa", EN: "Technology & Defense" } },
  { id: 6, vendor: "CASA ANTONIO GONZALEZ", title: " ", price: " ", image: "/IMG13.jpeg", quickView: { ES: "Viñedo, Arte y lifestyle", EN: "Vineyard, Art & Lifestyle" } },
  { id: 7, vendor: "INTERPLAY E. GROUP", title: " ", price: " ", image: "/IMG14.jpeg", quickView: { ES: "Entretenimiento, Music Business", EN: "Entertainment, Music Business" } },
  { id: 8, vendor: "NACIONAL MEDIA GROUP", title: " ", price: " ", image: "/IMG15.jpeg", quickView: { ES: "Social Media", EN: "Social Media" } },
  { id: 9, vendor: "AGZ MAISON", title: " ", price: " ", image: "/IMG16.jpeg", quickView: { ES: "Diseño, Alta costura", EN: "Design, Haute Couture" } },
  { id: 10, vendor: "THE AG GALLERY", title: " ", price: " ", image: "/IMG19.jpeg", quickView: { ES: "Arte y Experiencia", EN: "Art & Experience" } },
  { id: 11, vendor: "IN JET AMERICA", title: " ", price: " ", image: "/IMG18.jpeg", quickView: { ES: "TECNOLOGIA", EN: "TECHNOLOGY" } },
  { id: 12, vendor: "MAISON SANTA FE", title: " ", price: " ", image: "/IMG17.jpeg", quickView: { ES: "Night Club, lifestyle", EN: "Night Club, Lifestyle" } },
];

const estateProducts = [
  { id: 13, vendor: "BODEGA ANTONIO GONZÁLEZ", title: " ", price: " ", image: "/IMG20.jpeg", quickView: { ES: "viñedo", EN: "Vineyard" } },
  { id: 14, vendor: "REINA DEL VINO", title: " ", price: "", image: "/IMG21.jpeg", quickView: { ES: "CERTAMEN", EN: "PAGEANT" } },
  { id: 15, vendor: "BODEGA ANTONIO GONZÁLEZ", title: " ", price: " ", image: "/IMG22.jpeg", quickView: { ES: "viñedo", EN: "Vineyard" } },
  { id: 16, vendor: "FESTIVAL VV", title: " ", price: " ", image: "/IMG23.jpeg", quickView: { ES: "FESTIVAL", EN: "FESTIVAL" } },
];

// ─── CONTEXT de idioma ────────────────────────────
import { createContext, useContext } from "react";
const LangContext = createContext("ES");
const useLang = () => useContext(LangContext);

// ─── SUBCOMPONENTES ──────────────────────────────

function SearchModal({ onClose }) {
  const lang = useLang();
  const t = translations[lang];
  const [query, setQuery] = useState("");

  const allProducts = [...featuredProducts, ...lifestyleProducts, ...estateProducts];
  const normalize = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  const allItems = [
    ...allProducts
      .filter((p, index, self) => self.findIndex(x => x.vendor === p.vendor) === index)
      .map(p => {
        const vendorName = p.vendor.trim();
        let targetSection = "products";
        if (normalize(vendorName).includes("antonio gonzalez")) targetSection = "automotive";
        else if (normalize(vendorName).includes("effervescense")) targetSection = "lifestyle";
        else {
          targetSection = lifestyleProducts.find(x => x.id === p.id) ? "lifestyle"
                        : estateProducts.find(x => x.id === p.id) ? "estates"
                        : "products";
        }
        return { title: vendorName, tag: p.quickView ? p.quickView[lang] : null, section: targetSection };
      }),
    { title: "Bodega Antonio González", tag: lang === "ES" ? "Desde 1522" : "Since 1522", section: "automotive" },
    { title: "AG Effervescense", tag: "Vintage", section: "lifestyle" },
    { title: lang === "ES" ? "Ultimos Lanzamientos" : "Latest Launches", tag: " ", section: "products" },
    { title: lang === "ES" ? "Nuestras Divisiones" : "Our Divisions", tag: " ", section: "lifestyle" },
    { title: "Casa AG", tag: " ", section: "estates" },
  ];

  const results = query.length > 1
    ? allItems.filter((item, index, self) =>
        normalize(item.title).includes(normalize(query)) &&
        self.findIndex(t => t.title === item.title) === index
      )
    : [];

  const handleClick = (item) => {
    onClose();
    const titleLower = normalize(item.title);
    const isCasaAntonio = titleLower.includes("casa antonio gonzalez") || titleLower.includes("casa ag");
    const isBodegaAntonio = titleLower.includes("bodega antonio gonzalez") && !isCasaAntonio;
    const isEffervescense = titleLower.includes("effervescense");

    setTimeout(() => {
      let targetElement = null;
      if (isCasaAntonio || isBodegaAntonio || isEffervescense) {
        const allLabels = document.querySelectorAll('p, h3, span, .product-card_vendor');
        targetElement = Array.from(allLabels).find(el => {
          const text = normalize(el.textContent);
          if (isCasaAntonio) return text === "casa antonio gonzalez" || text === "casa ag";
          if (isBodegaAntonio) return text === "bodega antonio gonzalez";
          if (isEffervescense) return text.includes("effervescense");
          return false;
        });
      }
      const finalTarget = targetElement?.closest('.product-card') ||
                          document.querySelector(`[data-section="${item.section}"]`);
      if (finalTarget) {
        finalTarget.scrollIntoView({ behavior: "smooth", block: (isCasaAntonio || isBodegaAntonio || isEffervescense) ? "center" : "start" });
      }
    }, 400);
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 999999, background: "rgba(0,0,0,0.95)", display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "120px" }} onClick={onClose}>
      <div style={{ width: "100%", maxWidth: "600px", padding: "0 24px", position: "relative", zIndex: 1000000 }} onClick={e => e.stopPropagation()}>
        <input autoFocus value={query} onChange={e => setQuery(e.target.value)} placeholder={t.searchPlaceholder}
          style={{ width: "100%", background: "transparent", border: "none", borderBottom: "2px solid #ffffff", color: "#ffffff", fontSize: "28px", padding: "12px 0", fontFamily: "var(--font-display)", letterSpacing: "0.1em", outline: "none" }}
        />
        <div style={{ marginTop: "32px", maxHeight: "60vh", overflowY: "auto" }}>
          {results.map((item, i) => (
            <div key={i} onClick={() => handleClick(item)}
              style={{ padding: "18px 0", borderBottom: "1px solid rgba(255,255,255,0.15)", color: "#ffffff", fontSize: "16px", letterSpacing: "0.15em", textTransform: "uppercase", cursor: "pointer", transition: "color 0.2s", display: "flex", justifyContent: "space-between", alignItems: "center" }}
              onMouseEnter={e => e.currentTarget.style.color = "#b8972a"}
              onMouseLeave={e => e.currentTarget.style.color = "#ffffff"}
            >
              <span>{item.title}</span>
              {item.tag && <span style={{ fontSize: "11px", color: "#b8972a", marginLeft: "12px" }}>{item.tag}</span>}
            </div>
          ))}
          {query.length > 1 && results.length === 0 && (
            <p style={{ color: "#888", fontSize: "14px", letterSpacing: "0.1em", marginTop: "20px" }}>{t.searchEmpty} "{query}"</p>
          )}
        </div>
      </div>
    </div>
  );
}

function Navbar({ lang, setLang }) {
  const [visible, setVisible] = useState(true);
  const [lastY, setLastY] = useState(0);
  const [searchOpen, setSearchOpen] = useState(false);
  
  // Evaluamos si es móvil para corregir los desnumereados de posición inline
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY > lastY + 1) setVisible(false);
      else if (currentY < lastY - 5) setVisible(true);
      setLastY(currentY);
    };

    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [lastY]);

  const toggleLang = () => setLang(prev => prev === "ES" ? "EN" : "ES");

  return (
    <>
      {searchOpen && <SearchModal onClose={() => setSearchOpen(false)} />}
      <nav className="navbar" style={{
        transform: visible ? "translateY(0)" : "translateY(-100%)",
        transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
        background: lastY < 50 ? "transparent" : "rgba(0,0,0,0.88)",
        backdropFilter: lastY < 50 ? "none" : "blur(10px)",
        borderBottom: "none",
      }}>
        
        {/* IZQUIERDA — Botón traductor */}
        <div style={{ 
          alignSelf: "center", 
          position: "relative", 
          top: isMobile ? "0px" : "-75px" 
        }}>
          <button onClick={toggleLang} style={{
            background: "transparent",
            border: "none",               
            color: "white",
            // Si es móvil mantiene 14px (no se mueve nada); si es web usa 0px para emparejar con la lupa
            padding: isMobile ? "5px 14px" : "5px 14px 5px 0px",  
            fontSize: "11px",             
            letterSpacing: "0.2em",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            borderRadius: "0",          
            fontFamily: "'Montserrat', sans-serif", 
            textTransform: "uppercase",
            outline: "none",              
          }}>
            {/* Mundo forzado a color blanco */}
            <span style={{ filter: "brightness(0) invert(1)" }}> </span> {lang}
          </button>
        </div>

        {/* CENTRO — Logo (Intacto como lo tenías originalmente) */}
        <ul className="navbar__links">
          <li style={{ listStyle: "none", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <a href="">
              <img src="/IMG1_HE.PNG" style={{ height: "230px", objectFit: "contain", display: "block", position: "relative", top: "-75px" }} />
            </a>
          </li>
        </ul>

        {/* DERECHA — Search (Corregido para móvil) */}
        <div className="navbar__actions" style={{ 
          alignSelf: "center", 
          position: "relative", 
          top: isMobile ? "0px" : "-75px" 
        }}>
          <button className="navbar__icon-btn" aria-label="Buscar" onClick={() => setSearchOpen(true)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </button>
        </div>
      </nav>
    </>
  );
}

function Hero() {
  const videoRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <section className="hero" id="home" style={{ minHeight: "100vh" }}>
      <div className="hero__video-wrapper">
        <video ref={videoRef} autoPlay muted loop playsInline>
          <source src={isMobile ? "/VIDEO3MOVIL.mp4" : "/VIDEO2.mp4"} type="video/mp4" />
        </video>
      </div>
    </section>
  );
}

function ProductCard({ product }) {
  const lang = useLang();
  const [hovered, setHovered] = useState(false);
  const qv = product.quickView ? (typeof product.quickView === "object" ? product.quickView[lang] : product.quickView) : translations[lang].quickViewDefault;
  return (
    <div className="product-card" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <div className="product-card__img">
        <img src={product.image} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        {hovered && <div className="product-card__quick-view">{qv}</div>}
      </div>
      <p className="product-card__vendor">{product.vendor}</p>
      <h3 className="product-card__title">{product.title}</h3>
      <p className="product-card__price">{product.price}</p>
    </div>
  );
}

function ProductGrid({ products }) {
  return (
    <div className="products-grid">
      {products.map((p) => <ProductCard key={p.id} product={p} />)}
    </div>
  );
}

function AutomotiveBanner() {
  const lang = useLang();
  const t = translations[lang];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div style={{ position: "relative", width: "100%", height: isMobile ? "500px" : "600px", overflow: "hidden" }}>
      <img src="/IMG9.jpeg" alt="Automotive" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to right, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.7) 100%)" }} />
      <div style={{
        position: "absolute", top: "50%", left: "0", right: "0", transform: "translateY(-50%)",
        zIndex: 2, display: "flex", flexDirection: isMobile ? "column" : "row",
        alignItems: "center", justifyContent: isMobile ? "center" : "space-between",
        padding: isMobile ? "0 24px" : "0 120px", gap: isMobile ? "16px" : "0", boxSizing: "border-box",
      }}>
        <p className="section__body" style={{ color: "#ffffff", textAlign: "justify", maxWidth: isMobile ? "100%" : "550px", margin: 0 }}>
          {t.automotiveText}
        </p>
        {!isMobile && <a href=" " className="btn-outline" style={{ padding: "12px 80px", whiteSpace: "nowrap" }}>{t.automotiveBtn}</a>}
      </div>
    </div>
  );
}

function LifestyleBanner() {
  const lang = useLang();
  const t = translations[lang];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div style={{ position: "relative", width: "100%", height: "auto", overflow: "hidden", padding: isMobile ? "45px 24px 20px" : "45px 48px 20px" }}>
      <div style={{ position: "absolute", inset: 0, background: "#ffffff" }} />
      <div style={{ position: "relative", zIndex: 2, padding: isMobile ? "0" : "0 48px", textAlign: "center" }}>
        <h2 className="section__title" style={{ color: "#111111", fontWeight: "700", textAlign: "center" }}>
          {isMobile ? t.divisiones : t.nuestrasDivisiones}
        </h2>
        <p className="section__body" style={{ margin: "0 auto", textAlign: "justify", maxWidth: "928px", color: "#000000" }}>
          {t.lifestyleText}
        </p>
      </div>
    </div>
  );
}

function EstatesBanner() {
  const lang = useLang();
  const t = translations[lang];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Noto+Serif&display=swap');`}</style>
      <div style={{ position: "relative", width: "100%", height: "600px", overflow: "hidden" }}>
        <img src="/IMG4.jpg" alt="Estates" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to right, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 100%)" }} />
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", maxWidth: "600px", width: "100%", zIndex: 2, textAlign: "center", padding: isMobile ? "0 24px" : "0", boxSizing: "border-box" }}>
          <h2 className="section__title" style={{ fontFamily: "'Noto Serif', serif", fontWeight: 400 }}>{t.casaAgTitle}</h2>
          <p className="section__body" style={{ color: "#ccc", margin: "0 auto 32px", textAlign: isMobile ? "justify" : "center" }}>
            {t.casaAgText}
          </p>
          <a href="https://bodegaantoniogonzalez.com" target="_blank" rel="noopener noreferrer" className="btn-outline">{t.casaAgBtn}</a>
        </div>
      </div>
    </>
  );
}

function ExperienceBanner() {
  const lang = useLang();
  const t = translations[lang];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    return (
      <div style={{ background: "#ffffff", padding: "24px 24px 40px", display: "flex", flexDirection: "column", gap: "24px" }}>
        <h2 className="section__title" style={{ color: "#111", textAlign: "center" }}>{t.experienceTitle}</h2>
        <img src="/IMG11.jpeg" alt="Experience" style={{ width: "100%", height: "260px", objectFit: "cover" }} />
        <p className="section__body" style={{ color: "#444", marginTop: "24px", marginBottom: 0, textAlign: "justify" }}>{t.experienceText}</p>
        <a href="https://theaggallery.com" target="_blank" rel="noopener noreferrer" className="btn-outline" style={{ color: "#111", borderColor: "#111", alignSelf: "center", marginTop: "12px" }}>{t.experienceBtn}</a>
      </div>
    );
  }

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "stretch" }}>
      <div style={{ background: "#ffffff", display: "flex", flexDirection: "column", justifyContent: "center", padding: "80px 60px" }}>
        <h2 className="section__title" style={{ color: "#111" }}>{t.experienceTitle}</h2>
        <p className="section__body" style={{ color: "#444", maxWidth: "650px" }}>{t.experienceText}</p>
        <a href="https://theaggallery.com" target="_blank" rel="noopener noreferrer" className="btn-outline" style={{ color: "#111", borderColor: "#111", width: "fit-content" }}>{t.experienceBtn}</a>
      </div>
      <div style={{ background: "#ffffff", display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "40px 60px" }}>
        <img src="/IMG11.jpeg" alt="Experience" style={{ width: "100%", maxWidth: "400px", height: "400px", objectFit: "cover" }} />
      </div>
    </div>
  );
}

function Newsletter() {
  const lang = useLang();
  const t = translations[lang];
  const [email, setEmail] = useState("");
  const [agreed, setAgreed] = useState(false);
  const handleSubmit = () => {
    if (!email || !agreed) return;
    alert(`Subscribed: ${email}`);
    setEmail(""); setAgreed(false);
  };
  return (
    <section className="newsletter">
      <h2 className="newsletter__title">{t.newsletterTitle}</h2>
      <p style={{ fontSize: "12px", color: "#888", letterSpacing: "0.1em", marginBottom: "32px" }}>{t.newsletterSub}</p>
      <div className="newsletter__form">
        <input className="newsletter__input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
        <button className="newsletter__btn" onClick={handleSubmit}>{t.newsletterBtn}</button>
      </div>
      <label className="newsletter__consent">
        <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{ accentColor: "#b8972a" }} />
        {t.newsletterConsent}
      </label>
    </section>
  );
}

function Footer() {
  const lang = useLang();
  const t = translations[lang];
  return (
    <footer className="footer">
      <div className="footer__bottom" style={{ justifyContent: "center" }}>
        <p className="footer__copy">{t.footerCopy}</p>
      </div>
    </footer>
  );
}

// ─── COMPONENTE PRINCIPAL ────────────────────────
export default function WayneEnterprises() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [lang, setLang] = useState("ES");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const t = translations[lang];

  return (
    <LangContext.Provider value={lang}>
      <Navbar lang={lang} setLang={setLang} />
      <div style={{ minHeight: "100vh", background: "#0a0a0a" }}>
        <Hero />

        <section data-section="products" style={{ background: "#ffffff" }}>
          <div className="section" style={{ paddingBottom: "0", textAlign: "center", paddingTop: "45px" }}>
            <h2 className="section__title" style={{ color: "#111111", fontWeight: "700", marginBottom: "20px" }}>
              {isMobile ? t.lanzamientos : t.ultimosLanzamientos}
            </h2>
          </div>
          <ProductGrid products={featuredProducts} />
        </section>

        <section data-section="automotive" style={{ marginTop: "0px" }}>
          <AutomotiveBanner />
        </section>

        <section data-section="lifestyle" style={{ marginTop: "2px" }}>
          <LifestyleBanner />
          <ProductGrid products={lifestyleProducts} />
        </section>

        <section data-section="estates" style={{ marginTop: "2px" }}>
          <EstatesBanner />
          <ProductGrid products={estateProducts} />
        </section>

        <section data-section="experience" style={{ marginTop: "0px" }}>
          <ExperienceBanner />
        </section>

        <Footer />
      </div>
    </LangContext.Provider>
  );
}